module.exports = __webpack_public_path__ + "img/85.b226363.png";